// http://wx.hztywl.cn/bzb/h5.html?token=TOKEN_2ed5e2e6d99a4dbe95a8f37b22748a10#/cloud/clinc/pics?id=%s&clinicUserId=%s&errTitle=%s&errBody=%s
//http://localhost:8080/h5.html?token=TOKEN_2ed5e2e6d99a4dbe95a8f37b22748a10#/cloud/clinc/pics?id=1234&clinicUserId=345345&errTitle=已经付过钱&errBody=二日发吧

export default [
  //云诊室上传图片
  {
    path: '/cloud/clinc/pics',
    component: () => import('../pages/cloud_clinic/pics')
  },
  {
    path: '/cloud/clinc/result',
    component: () => import('../pages/cloud_clinic/result')
  },
]

//http://localhost:8081/h5.html?token=TOKEN_667eabfeb13047088616a0be95375201&version=3.1.974#/cloud/clinc/pics?id=262389354496&clinicUserId=258126008320&errTitle=&errBody=



// WEBPACK FOOTER //
// ./h5/router/cloudClinic.js